<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <ElSelect
            v-model="fieldValue"
            class="search-preference__select"
            :placeholder="removeHtml($t(fieldConfig.label))"
            size="small"
            :disabled="store.settingValues.automatic"
            @change="onChange"
        >
            <ElOption
                v-for="option in store.matchScoresOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
            />
        </ElSelect>
    </FieldItem>
</template>

<script>
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import FieldItem from '../components/FieldItem.vue';
import { FieldItemMixin } from './mixins';
import { removeHtml } from '../format';

export default {
    components: {
        FieldItem,
        ElSelect: Select,
        ElOption: Option,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'match_scores',
        },
    },
    methods: {
        removeHtml,
        onChange() {
            this.store.afterSetAlgorithmFields();
            this.syncChange();
        },
    },
};
</script>
